import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import QuickGuide from "./components/QuickGuide";
import RankingSection from "./components/RankingSection";
import ThemeCollection from "./components/ThemeCollection";
import NewReleases from "./components/NewReleases";
import Classics from "./components/Classics";
import Directors from "./components/Directors";
import WatchGuide from "./components/WatchGuide";
import FaqSection from "./components/FaqSection";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <QuickGuide />
        <RankingSection />
        <ThemeCollection />
        <NewReleases />
        <Classics />
        <Directors />
        <WatchGuide />
        <FaqSection />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}